'use strict';

var Sugar = require('sugar-core');

require('./build/buildClassCheckMethodsCall');

module.exports = Sugar.Object.isRegExp;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/isRegExp.js
// module id = 817
// module chunks = 0